/**
 * Update selected module
 * Endpoint: PUT /users/selected-module
 * Returns: 202 Accepted (empty body)
 */

import { axiosInstance } from '@configs/axios/axiosInstance';

import type { UpdateSelectedModuleRequest } from './updateSelectedModule.types';

export async function updateSelectedModule(
  payload: UpdateSelectedModuleRequest
): Promise<void> {
  await axiosInstance.put('/users/selected-module', payload);
  // Backend returns 202 Accepted with empty body
}
